import { defaultFill } from '../../../utils/constants';
var muiWarningFill16 = {
    paths: [
        {
            path: 'M8.49948544,0.136029742 C8.648963,0.223083883 8.77330271,0.347423593 8.86035685,0.496901145 L15.85658,12.5098658 C16.1345241,12.9871136 15.9729565,13.5993177 15.4957086,13.8772618 C15.3429162,13.9662464 15.1692619,14.0131281 14.9924463,14.0131281 L1,14.0131281 C0.44771525,14.0131281 -5.21804822e-15,13.5654128 -5.32907052e-15,13.0131281 C-5.32907052e-15,12.8363124 0.0468816505,12.6626581 0.135866297,12.5098658 L7.13208944,0.496901145 C7.41003353,0.0196532786 8.02223758,-0.141914351 8.49948544,0.136029742 Z M8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 Z M9,4 L7,4 L7,9 L9,9 L9,4 Z',
            fill: defaultFill,
        },
    ],
    title: 'Warning',
    width: 16,
    height: 15,
};
var muiWarningFill24 = {
    paths: [
        {
            path: 'M12.5196943,0.103764896 C12.6563533,0.186911566 12.7710712,0.301629474 12.8542179,0.438288465 L23.8313712,18.4802221 C24.1184366,18.9520398 23.9686653,19.5672361 23.4968477,19.8543014 C23.3402204,19.9495973 23.1604093,20 22.9770698,20 L1.0227631,20 C0.470478346,20 0.0227630956,19.5522847 0.0227630956,19 C0.0227630956,18.8166605 0.0731658138,18.6368494 0.168461651,18.4802221 L11.145615,0.438288465 C11.4326804,-0.0335291951 12.0478767,-0.183300498 12.5196943,0.103764896 Z M12,15 C11.1715729,15 10.5,15.6715729 10.5,16.5 C10.5,17.3284271 11.1715729,18 12,18 C12.8284271,18 13.5,17.3284271 13.5,16.5 C13.5,15.6715729 12.8284271,15 12,15 Z M13.5,6 L10.5,6 L10.5,13.5 L13.5,13.5 L13.5,6 Z',
            fill: defaultFill,
        },
    ],
    title: 'Warning',
    width: 24,
    height: 20,
};
var muiWarningFill = {
    base: muiWarningFill16,
    smIcon: muiWarningFill16,
    lgIcon: muiWarningFill24,
};
export { muiWarningFill };
//# sourceMappingURL=warningFill.js.map